import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';

function BugReportAdmin({ showToast, user }) {
  var [reports, setReports] = useState([]);
  var [filter, setFilter] = useState('all');
  var [detail, setDetail] = useState(null);
  var [reply, setReply] = useState('');
  var [saving, setSaving] = useState(false);
  var [ssUrl, setSsUrl] = useState('');
  var [gallery, setGallery] = useState([]);
  var [lightbox, setLightbox] = useState('');

  var loadReports = function() {
    authFetch(API + '/bug-reports').then(function(r) { return r.json(); }).then(function(d) {
      if (d.success) setReports(d.reports || []);
    }).catch(function() {});
  };

  useEffect(function() { loadReports(); }, []);

  var catKr = { bug: '버그', improvement: '개선요청', question: '질문' };
  var catIcon = { bug: '🐛', improvement: '💡', question: '❓' };
  var statusKr = { open: '접수', in_progress: '처리중', resolved: '해결', closed: '종료' };
  var statusColor = { open: '#3b82f6', in_progress: '#f59e0b', resolved: '#16a34a', closed: '#94a3b8' };

  var filtered = reports.filter(function(r) { return filter === 'all' || r.status === filter; });
  var counts = { all: reports.length, open: 0, in_progress: 0, resolved: 0, closed: 0 };
  reports.forEach(function(r) { if (counts[r.status] !== undefined) counts[r.status]++; });

  var openDetail = function(r) {
    setDetail(r);
    setReply(r.admin_reply || '');
    setSsUrl('');
    setGallery([]);
    if (r.screenshot) {
      authFetch(API + '/bug-reports/' + r.id + '/screenshot').then(function(res) { return res.blob(); }).then(function(blob) { setSsUrl(URL.createObjectURL(blob)); }).catch(function() { setSsUrl(''); });
    }
    if (r.screenshots && r.screenshots.length > 0) {
      var loaded = [];
      r.screenshots.forEach(function(s) {
        authFetch(API + '/bug-reports/' + r.id + '/screenshots/' + s.id).then(function(res) { return res.blob(); }).then(function(blob) {
          loaded.push({ id: s.id, url: URL.createObjectURL(blob), order_index: s.order_index });
          loaded.sort(function(a, b) { return a.order_index - b.order_index; });
          setGallery(loaded.slice());
        }).catch(function() {});
      });
    }
  };

  var updateReport = function(id, status, replyText) {
    setSaving(true);
    var body = { status: status };
    if (replyText !== undefined) body.admin_reply = replyText;
    authFetch(API + '/bug-reports/' + id, {
      method: 'PUT', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function(r) { return r.json(); }).then(function(d) {
      setSaving(false);
      if (d.success) { showToast('업데이트 완료'); loadReports(); if (detail) setDetail(Object.assign({}, detail, { status: status, admin_reply: replyText !== undefined ? replyText : detail.admin_reply })); }
      else { showToast(d.error || '실패', 'err'); }
    }).catch(function() { setSaving(false); showToast('서버 오류', 'err'); });
  };

  return (
    <div style={{ maxWidth: 1000, margin: '0 auto', padding: '16px 12px' }}>
      <h2 style={{ margin: '0 0 16px', fontSize: 20, fontWeight: 800, color: '#111' }}>오류 신고함</h2>

      {/* Filter tabs */}
      <div style={{ display: 'flex', gap: 6, marginBottom: 16 }}>
        {[['all', '전체'], ['open', '접수'], ['in_progress', '처리중'], ['resolved', '해결'], ['closed', '종료']].map(function(f) {
          var isActive = filter === f[0]; var cnt = counts[f[0]] || 0;
          var col = f[0] === 'all' ? '#475569' : (statusColor[f[0]] || '#94a3b8');
          return <button key={f[0]} onClick={function() { setFilter(f[0]); }} style={{ padding: '6px 14px', borderRadius: 20, fontSize: 12, fontWeight: 600, border: '2px solid ' + (isActive ? col : '#e5e7eb'), background: isActive ? col : '#fff', color: isActive ? '#fff' : col, cursor: 'pointer' }}>{f[1]} {cnt}</button>;
        })}
      </div>

      {/* Table */}
      <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead><tr style={{ background: '#f8f9fa', borderBottom: '2px solid #e5e7eb' }}>
            <th style={{ padding: '10px 12px', textAlign: 'center', width: 40, fontSize: 12, fontWeight: 600, color: '#475569' }}>#</th>
            <th style={{ padding: '10px 12px', textAlign: 'left', fontSize: 12, fontWeight: 600, color: '#475569' }}>업체</th>
            <th style={{ padding: '10px 12px', textAlign: 'center', width: 70, fontSize: 12, fontWeight: 600, color: '#475569' }}>분류</th>
            <th style={{ padding: '10px 12px', textAlign: 'left', fontSize: 12, fontWeight: 600, color: '#475569' }}>제목</th>
            <th style={{ padding: '10px 12px', textAlign: 'left', fontSize: 12, fontWeight: 600, color: '#475569' }}>신고자</th>
            <th style={{ padding: '10px 12px', textAlign: 'center', width: 130, fontSize: 12, fontWeight: 600, color: '#475569' }}>신고일</th>
            <th style={{ padding: '10px 12px', textAlign: 'center', width: 70, fontSize: 12, fontWeight: 600, color: '#475569' }}>상태</th>
            <th style={{ padding: '10px 12px', textAlign: 'center', width: 80, fontSize: 12, fontWeight: 600, color: '#475569' }}>작업</th>
          </tr></thead>
          <tbody>
            {filtered.length === 0 && <tr><td colSpan={8} style={{ textAlign: 'center', padding: '30px 0', color: '#aaa' }}>신고 내역이 없습니다</td></tr>}
            {filtered.map(function(r, ri) {
              var shotCount = (r.screenshots && r.screenshots.length) || (r.screenshot ? 1 : 0);
              return <tr key={r.id} style={{ borderBottom: '1px solid #f0f0f0', background: ri % 2 === 1 ? '#fafafa' : '#fff', cursor: 'pointer' }} onClick={function() { openDetail(r); }}>
                <td style={{ padding: '8px 12px', textAlign: 'center', color: '#999', fontSize: 12 }}>{r.id}</td>
                <td style={{ padding: '8px 12px', fontSize: 12 }}>{r.companyName || '-'}</td>
                <td style={{ padding: '8px 12px', textAlign: 'center' }}><span style={{ fontSize: 11 }}>{catIcon[r.category] || ''} {catKr[r.category] || r.category}</span></td>
                <td style={{ padding: '8px 12px', fontWeight: 600 }}>{r.title}{shotCount > 0 && <span style={{ fontSize: 10, color: '#3b82f6', marginLeft: 4 }}>📷 {shotCount}</span>}</td>
                <td style={{ padding: '8px 12px', fontSize: 12, color: '#555' }}>{r.userName || r.userLoginId || '-'}</td>
                <td style={{ padding: '8px 12px', textAlign: 'center', fontSize: 11, color: '#888' }}>{(r.created_at || '').slice(0, 16)}</td>
                <td style={{ padding: '8px 12px', textAlign: 'center' }}><span style={{ fontSize: 10, fontWeight: 600, padding: '2px 6px', borderRadius: 4, background: statusColor[r.status] || '#94a3b8', color: '#fff' }}>{statusKr[r.status] || r.status}</span></td>
                <td style={{ padding: '8px 12px', textAlign: 'center' }} onClick={function(e) { e.stopPropagation(); }}>
                  <select value={r.status} onChange={function(e) { updateReport(r.id, e.target.value); }} style={{ fontSize: 11, padding: '2px 4px', borderRadius: 4, border: '1px solid #d0d5dd', cursor: 'pointer' }}>
                    <option value="open">접수</option>
                    <option value="in_progress">처리중</option>
                    <option value="resolved">해결</option>
                    <option value="closed">종료</option>
                  </select>
                </td>
              </tr>;
            })}
          </tbody>
        </table>
      </div>

      {/* Detail modal */}
      {detail && <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }} onClick={function() { setDetail(null); }}>
        <div style={{ background: '#fff', borderRadius: 16, padding: 24, width: 560, maxWidth: '94vw', maxHeight: '85vh', overflowY: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }} onClick={function(e) { e.stopPropagation(); }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <h3 style={{ margin: 0, fontSize: 16 }}>#{detail.id} {catIcon[detail.category]} {detail.title}</h3>
            <button onClick={function() { setDetail(null); }} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#999' }}>✕</button>
          </div>
          <div style={{ display: 'flex', gap: 12, fontSize: 12, color: '#64748b', marginBottom: 12, flexWrap: 'wrap' }}>
            <span>신고자: <b>{detail.userName || '-'}</b></span>
            <span>업체: <b>{detail.companyName || '-'}</b></span>
            <span>분류: <b>{catKr[detail.category]}</b></span>
            <span>신고일: <b>{(detail.created_at || '').slice(0, 16)}</b></span>
            {detail.page && <span>페이지: <b>{detail.page}</b></span>}
          </div>
          {detail.description && <div style={{ padding: '12px 14px', background: '#f8fafc', borderRadius: 8, fontSize: 13, color: '#333', marginBottom: 12, whiteSpace: 'pre-wrap', border: '1px solid #e5e7eb' }}>{detail.description}</div>}
          {detail.screenshot && <div style={{ marginBottom: 12 }}>{ssUrl ? <img src={ssUrl} alt="screenshot" onClick={function() { setLightbox(ssUrl); }} style={{ maxWidth: '100%', maxHeight: 300, borderRadius: 8, border: '1px solid #e5e7eb', cursor: 'zoom-in' }} /> : <div style={{ padding: 12, textAlign: 'center', color: '#94a3b8', fontSize: 12 }}>스크린샷 로딩 중...</div>}</div>}
          {gallery.length > 0 && <div style={{ marginBottom: 12, display: 'flex', flexWrap: 'wrap', gap: 8 }}>
            {gallery.map(function(g) {
              return <img key={g.id} src={g.url} alt={'shot-' + g.id} onClick={function() { setLightbox(g.url); }} style={{ width: 130, height: 130, objectFit: 'cover', borderRadius: 8, border: '1px solid #e5e7eb', cursor: 'zoom-in' }} />;
            })}
          </div>}
          <div style={{ marginBottom: 12 }}>
            <label style={{ fontSize: 12, fontWeight: 600, color: '#475569', display: 'block', marginBottom: 4 }}>상태 변경</label>
            <select value={detail.status} onChange={function(e) { updateReport(detail.id, e.target.value); setDetail(Object.assign({}, detail, { status: e.target.value })); }} style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid #d0d5dd', fontSize: 13, cursor: 'pointer' }}>
              <option value="open">접수</option>
              <option value="in_progress">처리중</option>
              <option value="resolved">해결</option>
              <option value="closed">종료</option>
            </select>
          </div>
          <div style={{ marginBottom: 12 }}>
            <label style={{ fontSize: 12, fontWeight: 600, color: '#475569', display: 'block', marginBottom: 4 }}>관리자 답변</label>
            <textarea value={reply} onChange={function(e) { setReply(e.target.value); }} rows={4} placeholder="답변을 작성하세요" style={{ width: '100%', boxSizing: 'border-box', padding: '10px 12px', borderRadius: 8, border: '1px solid #d0d5dd', fontSize: 13, outline: 'none', resize: 'vertical' }} />
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={function() { setDetail(null); }} style={{ flex: 1, padding: '10px 0', borderRadius: 8, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 13, color: '#555' }}>닫기</button>
            <button onClick={function() { updateReport(detail.id, detail.status, reply); }} disabled={saving} style={{ flex: 1, padding: '10px 0', borderRadius: 8, border: 'none', background: saving ? '#aaa' : '#1B3A5C', color: '#fff', cursor: saving ? 'default' : 'pointer', fontSize: 13, fontWeight: 700 }}>{saving ? '저장 중...' : '답변 저장'}</button>
          </div>
        </div>
      </div>}

      {/* Lightbox */}
      {lightbox && <div onClick={function() { setLightbox(''); }} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.85)', zIndex: 999999, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'zoom-out' }}>
        <img src={lightbox} alt="zoom" style={{ maxWidth: '94vw', maxHeight: '94vh', borderRadius: 8 }} />
      </div>}
    </div>
  );
}

export default BugReportAdmin;
